import { Button, CircularProgress, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useGetStripeUrl } from '../../sic-lib/api/hooks/useStripe';
import AxiosErrorAlert from '../Shared/Alerts/AxiosErrorAlert';

export function OfferForm() {
    let { offerKey } = useParams<{ offerKey: string }>();
    //query for getting offer URL and sessionId goes here once Dermot is done

    const {
        data: stripeUrl,
        isLoading: isStripeUrlLoading,
        isError,
        error,
    } = useGetStripeUrl({ offerKey });

    if (isStripeUrlLoading) {
        return (
            <Grid container item justifyContent="center" alignContent="center">
                <CircularProgress />
            </Grid>
        );
    }

    if (isError) {
        return (
            <Grid container item justifyContent="center">
                <AxiosErrorAlert error={error} />
            </Grid>
        );
    }

    return (
        <Grid container item justifyContent="center" alignItems="center">
            <Button variant="contained" disabled={!stripeUrl} href={stripeUrl?.url}>
                Proceed to Checkout
            </Button>
        </Grid>
    );
}
